export default "__VITE_ASSET__272ae4d0__"